import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NextUITable,
} from "../../components"
import {
    Button
} from "@nextui-org/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { format } from "date-fns";

const OutwardReport = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [chalDate, setChalDate] = useState({
        fromDate: frDate(startDate) || null,
        toDate: frDate(endDate) || null
    })

    // useEffect(() => {
    //     if (isMultipleCompany)
    //         navigate(linksUrl.dashboard.tradingDashboard)
    // }, [])
    const columns = [
        { header: "Chal No", accessor: "Chal_No", type: "text", filterable: true, sortable: true },
        { header: "Date", accessor: "Chal_Date", type: "date", filterable: true, align:"center", sortable: true, },
        { header: "Party", accessor: "Pac_Desc", type: "text", filterable: true, sortable: true },
        { header: "Person Name", accessor: "PersonName", type: "text", filterable: true, sortable: true },
        { header: "Item", accessor: "Item_Desc", type: "text", filterable: true, width: "150px", sortable: true },
        { header: "No Of Catalog", accessor: "Pcs", type: "number", filterable: true, sortable:true,align:"right"},
        { header: "Remark", accessor: "Remark", type: "text", filterable: true, width: "120px", sortable: true },
    ]
    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.catalogEntry.fetch,
        queryKey: "Outward Catalog",

    })

    console.log(data)
    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                fromdate: chalDate?.fromDate,
                todate: chalDate?.toDate,
                billtype: 'O',
                action:"DETAIL"
            }
        })
    }

    const handleFilter = () => {
        funFilterData();
    }
    const handleClear = () => {
        setChalDate({
            fromDate: startDate || null,
            toDate: endDate || null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                fromdate: frDate(startDate),
                todate: frDate(endDate),
                billtype: 'O',
                action:"DETAIL"
            }
        })
    }
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };

    const formatNumber = (num) => {
        return Number(num || 0).toFixed(2);
    };

    // Calculate totals
  
    const thclass = 'px-2 py-1 border border-gray-300 '




    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }


    return (
        <div>


            <MainContainer
                pageName="Product Catalog Outward List"
                info={[]}
                breadcrumbs={["Product Catalog", "Outward List"]}
            >
                <div className="p-2 shadow mb-5">
                    {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                    <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                        <div className="flex no-wrap gap-5">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"From Date"}
                                    views={["day", "month", "year"]}
                                    size="small"
                                    format="DD/MM/YYYY"
                                    value={
                                        chalDate.fromDate
                                            ? dayjs(chalDate.fromDate)
                                            : chalDate.fromDate
                                    }
                                    onChange={(newValue) => {
                                        setChalDate((prev) => {
                                            return {
                                                ...prev,
                                                fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"To  Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    value={
                                        chalDate.toDate
                                            ? dayjs(chalDate.toDate)
                                            : chalDate.toDate
                                    }
                                    onChange={(newValue) => {
                                        setChalDate((prev) => {
                                            return {
                                                ...prev,
                                                toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex no-wrap gap-5 justify-center items-center">
                            <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Get Data</Button>
                            <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Reset Date</Button>
                        </div>
                    </div>
                </div>
                
                <MasterGrid
                    columns={columns}
                    data={data}
                    className={""}
                    showPaging={false}
                    pageSize={20}
                    expandableRow={false}
                    virtualize={false}
                    headClass={"bg-sky-600 border-1 text-white border-slate-300 font-semibold"}
                    filterClass={"bg-sky-50 border-1 border-slate-300"}
                    footerClass={"bg-sky-600 text-white"}
                    style={{ border: "1px solid red" }}
                    exportHeader={{
                        companyName: compName.join(","),
                        reportName: `Product Catalog OutWard List From ${formatDate(chalDate.fromDate)} To ${formatDate(chalDate.toDate)}`,

                    }}
                ></MasterGrid>
            </MainContainer>
        </div>
    )
}
export default OutwardReport
